import {Container} from 'inversify';
import {ServiceNames} from '../constant/ServiceNames';
import FolderService from '../service/FolderService';
import TransactionService from '../service/TransactionService';
import AuditService from '../service/AuditService';
import RuleService from '../service/RuleService';
import GroupService from '../service/GroupService';
import ListService from '../service/ListService';
import RoleService from '../service/RoleService';
import UserService from '../service/UserService';
import ComponentService from '../service/ComponentService';
import ListDataService from '../service/ListDataService';
import BasicVariableService from '../service/BasicVariableService';
import QueryVariableService from '../service/QueryVariableService';
import ListVariableService from '../service/ListVariableService';
import ApiVariableService from '../service/ApiVariableService';
import ConnectionService from '../service/ConnectionService';
import DomainConfigurationService from '../service/DomainConfigurationService';
import StructService from '../service/StructService';
import GatewayContainer from './GatewayContainer';
import DraggableItemService from '../components/folder/DraggableItemService';
import GatewayNames from '../constant/GatewayNames';
import CaseService from '../service/CaseService';
import VelocityVariableService from '../service/VelocityVariableService';
import StreamService from '../service/StreamService';
import ActionService from '../service/ActionService';
import JobService from '../service/JobService';
import ExpressionBridge from '../util/ExpressionBridge';
import NotificationService from '../service/NotificationService';
import {InstanceContainer} from './binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import WatchlistService from '../service/WatchlistService';
import CustomListService from '../service/CustomListService';
import ChartService from '../service/ChartService';
import DashboardService from '../service/DashboardService';
import AiModelService from '../service/AiModelService';
import EnrichmentService from '../service/EnrichmentService';
import TrackerService from '../service/TrackerService';
import EntityService from '../service/EntityService';
import CraService from "../service/CraService";
import AchService from 'service/AchService';

class ServiceContainer extends Container {
  private static instance: Container | null = null;

  private constructor(tenant: string) {
    super({autoBindInjectable: true, defaultScope: 'Singleton'});
    this.bind(ServiceNames.EXPRESSION_BRIDGE).toConstantValue(new ExpressionBridge());
    this.bind(ServiceNames.FOLDER).toConstantValue(new FolderService());
    this.bind(ServiceNames.CHANNEL).toConstantValue(new TransactionService());
    this.bind(ServiceNames.CASE).toConstantValue(new CaseService());
    this.bind(ServiceNames.ACH).toConstantValue(new AchService());
    this.bind(ServiceNames.ENTITY).toConstantValue(new EntityService());
    this.bind(ServiceNames.AUDIT).toConstantValue(new AuditService());
    this.bind(ServiceNames.FLOW).toConstantValue(new RuleService(this.get(ServiceNames.EXPRESSION_BRIDGE)));
    this.bind(ServiceNames.GROUP).toConstantValue(new GroupService());
    this.bind(ServiceNames.LIST_DATA).toConstantValue(new ListDataService());
    this.bind(ServiceNames.LIST).toConstantValue(new ListService(this.get(ServiceNames.LIST_DATA)));
    this.bind(ServiceNames.ROLE).toConstantValue(new RoleService());
    this.bind(ServiceNames.USER).toConstantValue(new UserService());
    this.bind(ServiceNames.COMPONENT).toConstantValue(new ComponentService());
    this.bind(ServiceNames.BASIC_VARIABLE).toConstantValue(new BasicVariableService());
    this.bind(ServiceNames.QUERY_VARIABLE).toConstantValue(new QueryVariableService());
    this.bind(ServiceNames.LIST_VARIABLE).toConstantValue(new ListVariableService(this.get(ServiceNames.EXPRESSION_BRIDGE)));
    this.bind(ServiceNames.API_VARIABLE).toConstantValue(new ApiVariableService());
    this.bind(ServiceNames.VELOCITY_VARIABLE).toConstantValue(new VelocityVariableService(this.get(ServiceNames.EXPRESSION_BRIDGE)));
    this.bind(ServiceNames.CONNECTION).toConstantValue(new ConnectionService());
    this.bind(ServiceNames.ENRICHMENT).toConstantValue(new EnrichmentService());
    this.bind(ServiceNames.DOMAIN_CONFIGURATION).toConstantValue(new DomainConfigurationService());
    this.bind(ServiceNames.STRUCT).toConstantValue(new StructService());
    this.bind(ServiceNames.DRAGGABLE_ITEM).toConstantValue(new DraggableItemService(GatewayContainer.getInstance().get(GatewayNames.FOLDER_CLIENT)));
    this.bind(ServiceNames.STREAM).toConstantValue(new StreamService(this.get(ServiceNames.EXPRESSION_BRIDGE)));
    this.bind(ServiceNames.ACTION).toConstantValue(new ActionService());
    this.bind(ServiceNames.WATCHLIST).toConstantValue(new WatchlistService());
    this.bind(ServiceNames.CUSTOM_LIST).toConstantValue(new CustomListService());
    this.bind(ServiceNames.JOB).toConstantValue(new JobService());
    this.bind(ServiceNames.TRACKER).toConstantValue(new TrackerService());
    this.bind(ServiceNames.CHART).toConstantValue(new ChartService(GatewayContainer.getInstance().get(GatewayNames.CHART_CLIENT)));
    this.bind(ServiceNames.DASHBOARD).toConstantValue(new DashboardService(GatewayContainer.getInstance().get(GatewayNames.DASHBOARD_CLIENT)));
    this.bind(ServiceNames.NOTIFICATION_SERVICE).toConstantValue(new NotificationService(InstanceContainer.get(Injectables.SOCKET_CLIENT)));
    this.bind(ServiceNames.AI_MODEL).toConstantValue(
      new AiModelService(
        GatewayContainer.getInstance().get(GatewayNames.AI_CLIENT),
        this.get(ServiceNames.EXPRESSION_BRIDGE),
        GatewayContainer.getInstance().get(GatewayNames.FOLDER_CLIENT),
      ));
    this.bind(ServiceNames.CRA).toConstantValue(new CraService(this.get(ServiceNames.EXPRESSION_BRIDGE)));
  }

  public static initialize(tenant: string) {
    ServiceContainer.getInstance(tenant);
  }

  public static getInstance(tenant?: string): Container {
    if (ServiceContainer.instance == null) {
      ServiceContainer.instance = new ServiceContainer(tenant!);
      return ServiceContainer.instance;
    } else {
      return ServiceContainer.instance!;
    }
  }
}

export default ServiceContainer;
